import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../../util/Constants";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import ApiUiController from "../../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { Button, Table } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import StackedChartComponent from "../chartComponent/MultiBarChart";
import FilterPannel from "../../filter/FilterPannel";
import moment from 'moment';
import FilterComplexPannel from "../../filter/FilterComplexPannel";

class LeadcallFeedbackBySalesperson extends React.Component {
  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Constants.Model);
    const feedbackOptions = model.call.fields.feedback.options || [];
    const userOptions = model.user.options || [];
    this.lead = model.lead;
    this.call = model.call;
    const leadFields = model.lead.fields;
    const leadKeys = Object.keys(leadFields).filter((key) => ["source", "project", "enquiry_date", "lead_status", "responsible_person"].includes(key));
    this.lFields = {};
    leadKeys.map((key) => this.lFields[key] = leadFields[key]);
    this.lead.fields = this.lFields;
    this.loggedInUserId = reactLocalStorage.getObject(Constants.LoggedInUser).user_id;
    this.state = {
      progressData: [],
      feedbackOptions,
      userOptions,
      filters: [{
        field: "responsible_person",
        condition: "in",
        value: `~${this.loggedInUserId}~`,
        model_key: 'call'
      }, {
        field: "date_time",
        condition: "in",
        value: `${moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')}~${moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')}`,
        model_key: 'call'
      }, {
        field: "complete",
        condition: "not-in",
        value: "",
        model_key: 'call'
      }, {
        field: "responsible_person",
        condition: "in",
        value: `~1~`,
        model_key: 'lead'
      }],
      tableData: [],
      series: [],
      inApiCall: false,
      isFilterOpen: true,
      exportData: [],
    };
  }

  componentDidMount() {
    this.fetchApi(this.state.filters, this.onSuccess, this.onFail);
  }


  fetchApi = (filters, onSuccess, onFail) => {
    const body = {
      filters: filters,
      modelx: "lead_model",
      modely: "call_model",
      x: "cl.feedback",
      y: "cl.responsible_person",
      z: "COUNT(cl.id)"
    };
    this.setState({ inApiCall: true });
    DailySalesReportAPI.getFixedreportWithDoubleModel(body, onSuccess, onFail);
  };

  parseData = (response) => {
    if (!response) return;
    //    Prepare table data
    const tableData = this.state.feedbackOptions.map((feedback) => {
      const row = { feedback: feedback.label };
      this.state.userOptions.forEach((person) => {
        // Calculate the total sum for each responsible person per feedback
        const totalSum = response
          ?.filter(
            (item) => {
              return item.feedback === feedback.value &&
                item.responsible_person === person.value;
            })
          ?.reduce((sum, item) => sum + (item.sum || 0), 0);

        row[person.label] = totalSum;
      });
      return row;
    });

    // Prepare chart series
    const series = this.state.userOptions.map((person) => ({
      name: person.label,
      data: this.state.feedbackOptions.map((feedback) => {
        // Calculate the total sum for each responsible person per feedback
        const totalSum = response
          ?.filter(
            (item) => {
              return item.feedback === feedback.value &&
                item.responsible_person === person.value;
            })
          ?.reduce((sum, item) => sum + (item.sum || 0), 0);

        return totalSum;
      }),
    }));
    return { tableData, series };
  };

  onSuccess = (data) => {
    const { tableData, series } = this.parseData(data);
    const exportData = tableData;
    this.setState({ tableData, series, exportData, inApiCall: false });
  };

  onFail = (err) => {
    console.log("Failed to fetch data", err);
  };

  toggleFilter = () => {
    this.setState((prevState) => ({
      isFilterOpen: !prevState.isFilterOpen,
    }));
  };

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters },
      this.fetchApi(this.state.filters, this.onSuccess, this.onFail));
  };

  render() {
    const { exportData, filters, isFilterOpen, inApiCall, userOptions, tableData, series } = this.state;
    let selectedUserId, filteredUserOptions;
    filters.map(filter => filter.field === 'responsible_person' ? selectedUserId = filter.value.split(Constants.Opt).filter(Boolean) : null);
    filteredUserOptions = userOptions.filter(user => {
      if (Boolean(selectedUserId)) {
        return selectedUserId?.some(id => parseInt(id) === user.value);
      }
      return true;
    });
    const table = (<Table bordered hover>
      <thead>
        <tr>
          <th></th>
          {filteredUserOptions.map((person, index) => (
            <th key={index}>{person.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableData.map((row, index) => (
          <tr key={index}>
            <td>{row.feedback}</td>
            {filteredUserOptions.map((person, idx) => (
              <td key={idx}>{row[person.label]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>);;

    return (
      <ApiUiController inApiCall={inApiCall}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-7">
                  <h1>Call Feedback By sales Person (Lead and Call Combine )</h1>
                </div>
                <div className="col-md-5">
                  <CSVLink
                    data={exportData} filename={`call_By_feedback_By_salesPerson_report.csv`}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.state.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid">
              <div className="row">
                <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
                  <StackedChartComponent progressOptions={this.state.feedbackOptions} progressSums={series} type={"multiBar"} />
                  <div className="col-md-12">{table}</div>
                </div>
                {this.state.isFilterOpen && (
                  <FilterComplexPannel
                    filters={filters}
                    modelX={this.lead}
                    modelY={this.call}
                    onFilterChange={this.onFilterChange}
                    isFilterOpen={this.state.isFilterOpen}
                    restrict={this.Restrict}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}



export default LeadcallFeedbackBySalesperson;

